module.exports = __webpack_public_path__ + "media/images/hitfun/bg.howtoprize-3871d54568c4330dd75604bad6c72967.png";